import React from 'react';
import { Popup } from '@mobiscroll/react';
import { formatDate } from '@mobiscroll/react';
import CustomEventPopup from '../CustomEventPopup';
import { hoverPopupConfig } from './popupConfig';
import { createCustomEventPopupConfig } from './customEventPopupConfig';

// Component that manages all popup rendering
export const EventPopupManager = ({
    // Resources and utility functions for the popup
    resources,
    flattenArr,
    
    // Main event popup
    isOpen,
    setOpen,
    isEdit,
    saveEvent,
    onClose,
    headerText,
    anchor,
    onDelete,
    onEventBusyChange,
    onHandleEventXChange,
    onHandleEventInvoicedChange,
    popupEventTitle,
    titleChange,
    popupEventDescription,
    descriptionChange,
    selectedColor,
    openColorPicker,
    isBusy,
    isX,
    isEditable,
    popupEventAllDay,
    allDayChange,
    popupEventDate,
    changeStartDate,
    changeEndDate,
    startRef,
    endRef,
    isChecked,
    handleResourceCheckInEvent,
    popupButtons,
    responsivePopup,
    changeColor,
    
    // Hover popup
    isHoverOpen,
    popupEventTime,
    popupEventCreated,
    popupEventEdited,
    eventContent,
    onMouseEnter,
    onMouseLeave,
    
    // Helper functions
    getDateFromTimestamp
}) => {

    return (
        <>
            {/* Main Event Popup */}
            <CustomEventPopup
                {...createCustomEventPopupConfig({
                    // Core popup state
                    isOpen,
                    setOpen,
                    isEdit,
                    saveEvent,
                    onClose,
                    anchor,
                    
                    // Event data
                    popupEventTitle,
                    popupEventDescription,
                    popupEventAllDay,
                    popupEventDate,
                    selectedColor,
                    isBusy,
                    isX,
                    isEditable,
                    isChecked,
                    
                    // Event handlers
                    titleChange,
                    descriptionChange,
                    allDayChange,
                    changeStartDate,
                    changeEndDate,
                    handleEventBusy: onEventBusyChange,
                    handleEventX: onHandleEventXChange,
                    handleEventInvoiced: onHandleEventInvoicedChange,
                    handleResourceCheckInEvent,
                    changeColor,
                    
                    // UI configuration
                    headerText,
                    popupButtons,
                    responsivePopup,
                    closeOnOverlayClick: true,
                    fullScreen: true,
                    
                    // Resources and references
                    items: flattenArr(resources),
                    startRef,
                    endRef,
                    onDelete
                })}
            />

            {/* Hover Popup */}
            <Popup
                {...hoverPopupConfig}
                anchor={anchor}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isOpen={isHoverOpen}
            >
                <div className="md-tooltip-container" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <div className="md-tooltip-header" style={{ backgroundColor: `${selectedColor}${Math.floor(0.4 * 255).toString(16).padStart(2, 0)}` }}>
                        <h1>{popupEventTitle}</h1>
                        <p className='popup-desc'>{popupEventDescription}</p>
                        {!popupEventAllDay && popupEventTime && popupEventTime.length === 2 && (
                            <p className='popup-time'>{popupEventTime[0]} - {popupEventTime[1]}</p>
                        )}
                        <div className='popup-desc'>
                            {popupEventCreated !== null ? (() => {
                                const createdDate = getDateFromTimestamp(popupEventCreated);
                                return createdDate ? (
                                    <p className='popup-desc'>Created at: {formatDate('DD.MM.YY', createdDate) + " : " + createdDate.toLocaleTimeString([], {
                                        hourCycle: 'h23',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}</p>
                                ) : null;
                            })() : null}
                            {popupEventEdited !== null ? (() => {
                                const editedDate = getDateFromTimestamp(popupEventEdited);
                                return editedDate ? (
                                    <p className='popup-desc'>Edited at: {formatDate('DD.MM.YY', editedDate) + " : " + editedDate.toLocaleTimeString([], {
                                        hourCycle: 'h23',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}</p>
                                ) : null;
                            })() : null}
                        </div>
                    </div>
                    <div className="md-tooltip-content-container">
                        <div className="md-tooltip-content">
                            <h2 className='selected-event-container'>Bemanning:</h2>
                            {eventContent.map(item => {
                                if (item.id <= 11) {
                                    return <div className='selected-event-crew' key={item.id}>{item.name}</div>
                                }
                                return null;
                            })}
                            <h2 className='selected-event-container'>{Math.max(...eventContent.map(item => item.id)) > 10 ? 'Equipment' : ''}</h2>
                            {eventContent.map(item => {
                                if (item.id > 11) {
                                    return <div className='selected-event-equipment' key={item.id}>{item.name}</div>
                                }
                                return null;
                            })}
                        </div>
                    </div>
                </div>
            </Popup>

            {/* Holiday Popup - Removed to CalendarComponent to fix ref timing issues */}
        </>
    );
};
